/* eslint-disable import/no-unresolved */
import { Dayjs } from "dayjs";
import { Reducer } from "redux";
import { filterOptionsInitialValue } from "src/helpers/Dashboard";
import { FilterOptions } from "src/helpers/Dashboard/interface";
import {
  SET_DASHBOARD_DATA,
  SET_LIMIT,
  PAGE_NO,
  SEARCH_QUERY,
  SEARCH_ON,
  DATE_FILTERS,
  SORT_BY,
  SET_TABLE_DATA,
  SET_FILTER_SAVED,
  SET_FILTER_OPTIONS
} from "src/redux/Types/dashboard";

export interface DashboardDetails {
  data: Record<string, any>;
  tableData: Record<string, any>;
  pageNo: number;
  searchQuery: string;
  searchOn: string;
  dateFilters: {
    startDate: Dayjs | null;
    endDate: Dayjs | null;
  };
  sortBy: Record<string, string>;
  limit: number;
  filterOptions: FilterOptions;
  isFilterSaved: boolean;
}

const initialState: DashboardDetails = {
  data: {},
  tableData: [],
  pageNo: 1,
  searchQuery: "",
  sortBy: { priorityOrder: "ASC" },
  searchOn: "",
  dateFilters: {
    startDate: null,
    endDate: null
  },
  limit: 10,
  filterOptions: filterOptionsInitialValue,
  isFilterSaved: false
};

// eslint-disable-next-line default-param-last
const dashboardReducer: Reducer<DashboardDetails> = (state = initialState, action) => {
  switch (action.type) {
    case SET_DASHBOARD_DATA: {
      const { data } = action.payload;
      // console.log("dashboard data", data);
      const dashboardLeadMapping = data?.reduce(
        (acc: Record<string, any>, ele: Record<string, any>) => {
          acc[ele?.id] = ele;
          return acc;
        },
        {}
      );
      return {
        ...state,
        data: { ...state.data, ...action.payload, data: dashboardLeadMapping }
      };
    }
    case SET_TABLE_DATA: {
      return { ...state, tableData: action.payload };
    }
    case SORT_BY: {
      return {
        ...state,
        sortBy: { [action.payload]: state.sortBy[action.payload] === "ASC" ? "DESC" : "ASC" }
      };
    }
    case SEARCH_QUERY: {
      return { ...state, searchQuery: action.payload };
    }
    case SEARCH_ON: {
      return { ...state, searchOn: action.payload };
    }
    case DATE_FILTERS: {
      return { ...state, dateFilters: action.payload };
    }
    case PAGE_NO: {
      return { ...state, pageNo: action.payload };
    }
    case SET_LIMIT: {
      return { ...state, limit: action.payload };
    }
    case SET_FILTER_SAVED: {
      return { ...state, isFilterSaved: action.payload };
    }
    case SET_FILTER_OPTIONS: {
      return { ...state, filterOptions: action.payload };
    }
    default:
      return state;
  }
};

export default dashboardReducer;
